import BindAccount from '../../pages/mobile/wx/bindAccount'

const wx = [
    {path: '/wx/bindAccount', component: BindAccount},  //绑定账号
];
export default wx;
